module.exports = __webpack_public_path__ + "img/832.99688369.png";